var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type && _vm.models)?_c('b-container',{attrs:{"fluid":""}},[_c('page-title',{attrs:{"icon":"fas fa-tachometer-alt"}},[_c('translate',[_vm._v("OCR Control")])],1),_vm._v(" "),_c('api-list',{attrs:{"type":"ocr-control","model":_vm.models.ocrControl,"quick-filters":_vm.quickFiltersSetup.ocrControl}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }